import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { acceptInvitation } from "../../services/adminService";
import { passwordError } from "../../utils/passwordValidation";
import { getApiErrorMessage, retryAfterSeconds } from "../../utils/apiError";
import "../LoginPage/LoginPage.css";

export default function AcceptInvitationPage() {
  // Capture before scrubbing; never put the credentials in storage or router state.
  const [credentials] = useState(() => {
    const query = new URLSearchParams(window.location.search);
    return { requestId: query.get("requestId") || "", token: query.get("token") || "" };
  });
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [retryAt, setRetryAt] = useState(0);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete("requestId"); url.searchParams.delete("token");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    document.title = "Accept invitation | Navo+ Admin";
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  const valid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(credentials.requestId) && /^[A-Za-z0-9_-]{43}$/.test(credentials.token);
  const cooldown = Math.max(0, Math.ceil((retryAt - now) / 1000));
  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    const validation = passwordError(password, confirmPassword);
    if (validation) { setError(validation); return; }
    setBusy(true); setError("");
    try { await acceptInvitation({ ...credentials, password, confirmPassword }); setPassword(""); setConfirmPassword(""); setDone(true); }
    catch (err) { setError(getApiErrorMessage(err, "Unable to accept this invitation. It may have expired or been replaced. Request a resend from your administrator.")); setRetryAt(Date.now() + retryAfterSeconds(err) * 1000); }
    finally { setBusy(false); }
  };
  return <div className="login-page-container"><div className="login-form-card">
    <div className="login-header"><p>Navo+ Admin</p><h1>Accept invitation</h1></div>
    {!valid ? <div role="alert"><p>This invitation link is incomplete or invalid. Request a new link from your administrator.</p><Link to="/login">Go to sign in</Link></div> : done ? <div role="status"><p>Your password is set. Sign in and enroll your authenticator to open your workspace.</p><Link to="/login">Continue to sign in</Link></div> : <form onSubmit={submit}>
      <p>Choose your password to accept the invitation. Your administrator has already assigned your access.</p>
      {error && <p className="login-error-message" role="alert">{error}</p>}
      {cooldown > 0 && <p role="status">Try again in {cooldown} seconds.</p>}
      <div className="form-group"><label htmlFor="new-password">Password</label><input id="new-password" type="password" autoComplete="new-password" minLength={8} maxLength={72} value={password} onChange={event => setPassword(event.target.value)} required /></div>
      <div className="form-group"><label htmlFor="confirm-password">Confirm password</label><input id="confirm-password" type="password" autoComplete="new-password" maxLength={72} value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} required /></div>
      <p className="login-help">Use 8–72 characters with uppercase and lowercase letters, a number, and a special character.</p>
      <button className="login-button" disabled={busy || cooldown > 0}>{busy ? "Accepting..." : "Accept invitation"}</button>
      <p className="login-help">Expired or replaced link? Request a resend from your administrator.</p>
    </form>}
  </div></div>;
}
